// extracted by mini-css-extract-plugin
module.exports = {"content":"_7a3fb80146--content--AL97H"};